<template>
  <div class="myinfo">
    <div class="form-horizontal myform">
      <div class="input-group">
        <span class="input-group-addon border"><i class="iconfont icon-yonghu"></i></span>
        <a-input
          type="text"
          style="height: 35.75px"
          class="form-control"
          :placeholder="accountTip ? accountTip : '请输入账户'"
          aria-describedby="basic-addon1"
          @blur="usernameBlur"
          v-model="username"
        />
      </div>
      <div class="input-group" v-if="archives.length >= 2">
        <span class="input-group-addon border"><i class="iconfont icon-shouji"></i></span>
        <select class="form-control select" @change="change($event)">
          <option v-for="item in archives" :key="item.id" :value="item.id">{{ item.eduName }}-{{ item.grade }}-{{ item.proName }}</option>
        </select>
      </div>
      <div class="input-group">
        <span class="input-group-addon"><i class="iconfont icon-mima1"></i></span>
        <a-input type="password" style="height: 35.75px" class="form-control" placeholder="请输入密码" aria-describedby="basic-addon1" v-model="password" />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><i class="iconfont icon-anquanxing"></i></span>
        <a-input
          type="text"
          style="height: 35.75px"
          class="form-control"
          placeholder="请输入图形验证码(不区分大小写)"
          aria-describedby="basic-addon1"
          v-model="captcha"
          @pressEnter="submit"
        />
        <button type="submit" class="btn btn-default form-control sub" @click="getRandomImage" v-if="!imageCode">
          获取验证码
        </button>
        <img :src="imageCode" v-else @click="getRandomImage" />
      </div>
      <div class="agreement">
        <a-checkbox :checked="acceptCheck" @change="onCheckChange">
          阅读并同意
          <span class="clickText" @mousedown.prevent @click.stop="handleUserAgree">用户协议</span>
          和
          <span class="clickText" @mousedown.prevent @click.stop="handlePrivacyPolicy">隐私政策</span>
        </a-checkbox>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <a-spin :spinning="submitSpinning">
            <!-- 账户提交 -->
            <button type="submit" class="btn btn-default form-control sub" @click="submit">
              登录
            </button>
          </a-spin>
        </div>
      </div>
      <div class="pull-right">
        <!-- <router-link to="/userbind">绑定手机号</router-link> -->
        <router-link to="/findpwd">忘记密码</router-link>
      </div>
    </div>

    <a-modal
      title="动态验证 "
      :width="500"
      :visible="is2ValidVisible"
      :closable="false"
      :maskClosable="false"
      :cancelText="'关闭'"
      :okText="'进入'"
      @cancel="handleCancel"
      @ok="handleOk"
    >
      <p style="padding: 0 0 15px 40px; font-size: 14px; font-weight: 600">
        1.请打开微信扫码获取动态验证码
      </p>
      <p style="padding: 0 0 15px 40px; font-size: 14px; font-weight: 600">
        2.如没有绑定微信请您关注公众号，绑定后重新扫码
      </p>
      <div
        style="
          width: 130px;
          height: 130px;
          margin: 0 auto;
          box-sizing: border-box;
        "
        v-if="QRCodeUrl"
      >
        <img :src="QRCodeUrl" alt="" style="width: 130px; height: 130px" />
      </div>
      <div style="margin: 0 auto;">
        <div style="text-align: center;margin:10px 0;color:red;">请输入账户[{{ username }}]的验证码</div>
        <div style="text-align: center;">
          <a-input v-model="validCode" placeholder="" @input="handeleInput" style="width: 60%"></a-input>
        </div>
      </div>
    </a-modal>

    <a-modal
      title="短信验证 "
      :width="500"
      :visible="SmsCheck"
      :closable="false"
      :maskClosable="false"
      :cancelText="'关闭'"
      :okText="'进入'"
      @ok="handleOkSms"
      @cancel="fromSmsClose"
    >
      <div class="myinfo">
        <div class="form-horizontal myform">
          <div class="input-group">
            <span class="input-group-addon border"><i class="iconfont icon-shouji"></i></span>
            <input type="text" class="form-control" placeholder="请输入手机号" aria-describedby="basic-addon1" v-model="SMS.phone" :disabled="true" />
          </div>
          <div class="input-group">
            <span class="input-group-addon"><i class="iconfont icon-anquanxing"></i></span>
            <input type="text" class="form-control" placeholder="请输入图形验证码" aria-describedby="basic-addon1" v-model="SMS.captcha" />
            <img :src="imageCodeSMS" @click="getRandomImageSMS" />
          </div>
          <div class="input-group">
            <span class="input-group-addon"><i class="iconfont icon-anquanxing"></i></span>
            <a-input
              type="text"
              style="height: 35.75px"
              class="form-control"
              placeholder="请输入短信验证码"
              aria-describedby="basic-addon1"
              v-model="SMS.smsCheckCode"
              @pressEnter="submit"
            />
            <button type="submit" class="btn btn-default form-control sub" @click="getSms" :disabled="smsDisabled">
              {{ smsMessage }}
            </button>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model:open="openMfa"
      title="MFA验证"
      @ok="handleOkMfa"
      :okButtonProps="{
        style: {
          background: '#2caf7a',
          border: '1px solid #2caf7a',
        },
      }"
    >
      此账号已开通MFA安全验证:
      <a-input v-model:value="admMfa" placeholder="请输入动态验证码" />
    </a-modal>
  </div>
</template>

<script>
import JsEncrypt from 'jsencrypt'; // 引入JsEncrypt用于加密密码，避免明文传输带来的风险
import common from '@/common/js/common.js';
import vue from '../../../main.js';
import qrcode from 'qrcode';
import Cookies from 'js-cookie';
export default {
  props: {
    acceptCheck: {
      type: Boolean,
      default: false,
    },
    changeAcceptCheck: {
      type: Function,
      default: () => {},
    },
    accountTip: {
      type: String,
      default: '',
    },
  },
  name: 'ChangeStatefirst',
  data: function() {
    return {
      randomCode: null,
      publicKey: null,
      uuid: null,
      imageCode: `/static/images/checkcode.png`,
      imageCodeSMS: `/static/images/checkcode.png`,
      username: '',
      userid: '',
      password: '',
      captcha: '',
      archives: [],
      submitSpinning: false,
      is2ValidObj: {},
      is2ValidVisible: false, //二次验证弹窗
      QRCodeUrl: '',
      validCode: '',
      SmsCheck: false, //短信验证弹窗
      SMS: {
        smsCheckCode: null,
        phone: null,
        captcha: null,
        checkKey: null,
      },
      smsMessage: `获取短信验证码`,
      smsDisabled: false,
      smsObject: {},
      openMfa: false,
      admMfa: null,
      adm2valid: null,
    };
  },
  // mounted() {
  //   console.log('login/mounted');
  //   const number = parseInt(Math.random(1) * Math.pow(10, 10));
  //   console.log(number);
  //   this.randomCode = number;
  //   this.getRandomImage(); //获取图形验证码
  //   this.loadLoginToken(); //获取加密RSA
  // },
  mounted() {
    const number = parseInt(Math.random(1) * Math.pow(10, 10));
    this.randomCode = number;

    this.loadLoginToken(); // 获取加密RSA
    // this.getRandomImageSMS()
  },
  watch: {
    SmsCheck(newV, oldV) {
      if (newV === true) {
        this.getRandomImageSMS();
      }
    },
  },
  methods: {
    handleOkMfa() {
      let params = this.adm2valid;
      params.validCode = this.admMfa;
      this.axios.post(`/sys/admLogin/2valid`, params).then(res => {
        if (res.code === 200) {
          console.log(res);
          if (res.result.userInfo && res.result.userInfo.eduCode != '125') {
            Cookies.remove('loginType');
          }
          window.location.href = process.env.admHost + '/unifyLogin?token=' + res.result.token;
        }
      });
    },
    getQRCode(authUrl) {
      const QRCode = require('qrcode');
      // 生成Base64供前端直接使用
      QRCode.toDataURL(authUrl, { errorCorrectionLevel: 'H' }, (err, base64) => {
        if (!err) this.QRCodeUrl = base64; // 返回给前端作为<img>的src
      });
    },

    handleOkSms() {
      let params = {};
      params.uuid = this.smsObject.uuid;
      params.smsCode = this.SMS.smsCheckCode;
      this.axios.post(`/sys/validSms`, params).then(res => {
        if (res.code === 200) {
          this.fromSmsEnter();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getSms() {
      if (!this.SMS.phone) {
        this.$message.warning('请输入手机号');
        return;
      }
      // if (!this.SMS.smsCheckCode) {
      //   this.$message.warning('请输入验证码')
      //   return
      // }
      if (!this.SMS.captcha) {
        this.$message.warning('请输入图形验证码');
        return;
      }
      this.sendSms();
    },
    handleCancel() {
      // this.is2ValidVisible = false
      window.location.reload(true);
      this.is2ValidObj = {};
      this.validCode = '';
    },

    fromSmsEnter() {
      if (!this.smsObject.uuid) {
        this.$message.error('uuid不存在!');
        return;
      }
      let params = {};
      params = this.smsObject;
      this.axios
        .post(`/sys/login/2valid`, params)
        .then(res => {
          if (res.code === 200 && res.result.passValid === 1) {
            let userInfo = res.result.userInfo;
            userInfo.eduHomeUrl = res.result.eduHomeUrl || null;
            userInfo.eduLogo = res.result.eduLogo || null;
            userInfo.headTitle = res.result.headTitle;
            this.common.loginSuccess(res.result.token, userInfo);
            localStorage.setItem('WEAK_PASSWORD', res.result.weakPassword);
            // 登陆成功拿homeObj
            // this.axios.get(`/biz/home/param`).then(res => {
            //   if (res.code === 200) {
            //     // this.homeObj = res.result
            //     // console.log(this.homeObj,'header')
            //     this.$store.state.homeObj = res.result
            //     localStorage.setItem('isNeedAuth', res.result.isNeedAuth)
            //     localStorage.setItem('homeObj', JSON.stringify(res.result))
            //     console.log(this.$store.state.homeObj, 'Vuex')
            //   }
            // })
            this.SmsCheck = false;
          } else if (res.code === 200 && res.result.code === 1003) {
            this.SmsCheck = false;
            this.getQRCode(res.result.qrCodeStr); //获取二维码链接
            console.log(res.result.qrCodeStr, 'res.result.qrCodeStr');
            this.is2ValidVisible = true;

            this.$mssage.warning(res.result.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.getRandomImageSMS();
        })
        .finally(() => {
          this.submitSpinning = false;
        });
    },

    fromSmsClose() {
      window.location.reload(true);
      this.smsObject = {};
      this.validCode = '';
      this.SMS = {};
      this.SmsCheck = false;
    },

    handleOk() {
      if (!this.smsObject.uuid) {
        this.$message.warning('uuid不存在!');
        return;
      }
      if (!this.validCode || this.validCode === '') {
        this.$message.warning('请输入二次校验码!');
        return;
      }
      let params = {};
      params.validCode = this.validCode;
      params.uuid = this.smsObject.uuid;
      this.axios.post(`/sys/validMfa`, params).then(item => {
        if (item.code === 200) {
          this.axios
            .post(`/sys/login/2valid`, this.smsObject)
            .then(res => {
              if (res.code === 200) {
                let userInfo = res.result.userInfo;
                userInfo.eduHomeUrl = res.result.eduHomeUrl || null;
                userInfo.eduLogo = res.result.eduLogo || null;
                userInfo.headTitle = res.result.headTitle;
                this.common.loginSuccess(res.result.token, userInfo);
                localStorage.setItem('isNeedAuth', res.result.isNeedAuth);
                localStorage.setItem('WEAK_PASSWORD', res.result.weakPassword);
                // 登陆成功拿homeObj
                // this.axios.get(`/biz/home/param`).then(res => {
                //   if (res.code === 200) {
                //     // this.homeObj = res.result
                //     // console.log(this.homeObj,'header')
                //     this.$store.state.homeObj = res.result
                //     localStorage.setItem('homeObj', JSON.stringify(res.result))
                //     console.log(this.$store.state.homeObj, 'Vuex')
                //   }
                // })
                this.smsObject = {};
                this.SMS = {};
                this.is2ValidVisible = false;
                this.is2ValidObj = {};
                this.validCode = '';
              } else if (res.code === 511) {
                this.$message.error(res.message);
                this.is2ValidVisible = false;
                this.handleCancel();
              } else {
                this.validCode = '';
                this.is2ValidObj.validCode = '';
                this.$message.error(res.message);
              }
            })
            .catch(() => {
              this.getRandomImage();
            })
            .finally(() => {
              this.submitSpinning = false;
            });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handeleInput() {
      if (this.validCode.length > 6) {
        this.validCode = this.validCode.slice(0, 6);
      }
    },
    change(e) {
      this.userid = e.target.value;
    },
    getRandomImage() {
      if (!this.uuid) {
        this.$message.error('未拿到uuid');
        return;
      }
      this.axios.get(`/sys/randomImage/${this.uuid}`).then(res => {
        console.log(res.result);
        this.imageCode = res.result;
      });
    },

    getRandomImageSMS() {
      if (!this.smsObject.uuid) {
        this.$message.error('未拿到uuid');
        return;
      }
      this.axios.get(`/sys/randomImage/${this.smsObject.uuid}`).then(res => {
        console.log(res.result);
        this.imageCodeSMS = res.result;
      });
    },
    loadLoginToken() {
      this.axios.get(`/sys/login/token`).then(res => {
        this.publicKey = res.result.publicKey;
        this.uuid = res.result.uuid;
        this.getRandomImage(); // 拿到token后 获取图形验证码
      });
    },
    usernameBlur() {
      if (!this.username) return;
      this.axios
        .get(`/sys/archives/username`, {
          params: {
            username: this.username,
          },
        })
        .then(res => {
          this.archives = res.result;
          if (res.result.length > 1) {
            this.userid = res.result[0].id;
          } else if (res.result.length === 1) {
            this.userid = res.result[0].id;
          } else {
            this.userid = null;
            // "无内容"
            this.$refs.uToast.show({
              title: '账户暂未注册',
            });
          }
        });
    },

    sendSms() {
      this.axios
        .post(`/sys/sms`, {
          captcha: this.SMS.captcha,
          checkKey: this.smsObject.uuid,
          mobile: this.SMS.phone,
        })
        .then(res => {
          if (res.success) {
            this.$message.success('发送成功');
            this.countdown(300);
          } else {
            this.getRandomImageSMS();
          }
        })
        .catch(() => {
          this.getRandomImageSMS();
        });
    },

    countdown(index) {
      let countdownData = index;
      this.smsDisabled = true;

      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`;
          countdownData--;
        } else {
          this.smsMessage = `获取短信验证码`;
          this.smsDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    CheckSmsOrvalid(params) {
      this.SMS = {};
      this.axios
        .post(`/sys/login/2valid`, params)
        .then(res => {
          if (res.code === 200 && res.result.passValid === 1) {
            let userInfo = res.result.userInfo;
            if (userInfo.eduCode != '125') {
              Cookies.remove('loginType');
            }
            userInfo.eduHomeUrl = res.result.eduHomeUrl || null;
            userInfo.eduLogo = res.result.eduLogo || null;
            userInfo.headTitle = res.result.headTitle;
            this.common.loginSuccess(res.result.token, userInfo);
            localStorage.setItem('isNeedAuth', res.result.isNeedAuth);
            localStorage.setItem('WEAK_PASSWORD', res.result.weakPassword);
            // 登陆成功拿homeObj
            // this.axios.get(`/biz/home/param`).then(res => {
            //   if (res.code === 200) {
            //     // this.homeObj = res.result
            //     // console.log(this.homeObj,'header')
            //     this.$store.state.homeObj = res.result
            //     localStorage.setItem('homeObj', JSON.stringify(res.result))
            //     console.log(this.$store.state.homeObj, 'Vuex')
            //   }
            // })
            this.is2ValidVisible = false;
            this.is2ValidObj = {};
            this.validCode = '';
          } else if (res.code === 200 && res.result.code === 1002) {
            this.SMS.phone = res.result.phone;
            this.SmsCheck = true;
          } else if (res.code === 200 && res.result.code === 1003) {
            this.SmsCheck = false;
            this.getQRCode(res.result.qrCodeStr); //获取二维码链接
            this.is2ValidVisible = true;
            this.$mssage.warning(res.result.message);
          } else if (res.code === 200 && res.result.code === 1001) {
            // common.judgeAlertOrMessage(res.result.message)
            vue.$warning({
              title: '温馨提示',
              icon: 'smile',
              content: res.result.message,
              centered: true,
              okButtonProps: {
                style: { background: '#2caf7a', border: `1px solid #2caf7a` },
              },
              onOk: () => {
                window.location.reload(true);
              },
            });
          } else if (res.code === 511) {
            this.$message.error(res.message);
            this.is2ValidVisible = false;
            this.handleCancel();
          } else {
            this.validCode = '';
            this.is2ValidObj.validCode = '';
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.getRandomImage();
        })
        .finally(() => {
          this.submitSpinning = false;
        });
    },
    submit() {
      if (!this.acceptCheck) {
        this.submitSpinning = false;
        this.$message.error('请同意用户协议和隐私政策');
        return;
      }

      if (!this.username) {
        this.submitSpinning = false;
        this.$message.error('请输入账户', 1);
        return;
      }
      if (!this.password) {
        this.submitSpinning = false;
        this.$message.error('请输入密码', 1);
        return;
      }
      if (!this.captcha) {
        this.submitSpinning = false;
        this.$message.error('请输入验证码', 1);
        return;
      }
      this.submitSpinning = true;
      const jse = new JsEncrypt();
      let loginParams = {
        captcha: this.captcha,
        checkKey: this.uuid,
        devideType: 1,
        username: this.username,
        password: null,
        uuid: this.uuid,
        userid: this.userid,
      };
      jse.setPublicKey(this.publicKey);
      loginParams.password = jse.encrypt(this.password);
      this.axios
        .post(`/sys/zualogin`, loginParams)
        .then(res => {
          console.log(res);
          if (res.code === 200) {
            if (res.result.userInfo && res.result.userInfo.eduCode != '125') {
              Cookies.remove('loginType');
            }
            if (res.result.loginType == 2) {
              if (!res.result.is2Valid || res.result.is2Valid == 0) {
                window.location.href = process.env.admHost + '/unifyLogin?token=' + res.result.token;
              } else {
                this.adm2valid = res.result;
                this.openMfa = true;
              }
            } else {
              if (res.result.uuid) {
                this.smsObject = res.result;
                this.CheckSmsOrvalid(res.result);
                // this.is2ValidObj = res.result
                // this.is2ValidVisible = true
                return;
              }
            }
          } else {
            this.getRandomImage();
          }
          this.submitSpinning = false;
        })
        .catch(() => {
          this.getRandomImage();
          this.submitSpinning = false;
        });
    },
    onCheckChange() {
      this.$emit('changeAcceptCheck');
    },
    handleUserAgree(event) {
      event.preventDefault();
      // window.open('https://app.jxjypt.cn/yhxy.html', '_blank');
      window.open('https://videos.jxjypt.cn/cj21/yhxy.html', '_blank');
    },
    handlePrivacyPolicy(event) {
      event.preventDefault();
      // window.open('https://app.jxjypt.cn/yszc.html', '_blank');
      window.open('https://videos.jxjypt.cn/cj21/yszc.html', '_blank');
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  padding: 28px;
  margin-top: 20px;
}

.clickText {
  color: #1890ff;
  margin-left: 2px;
  margin-right: 2px;
}

.agreement {
  margin-bottom: 10px;
  font-size: 12px;
  color: #999;
}

.myform {
  width: 440px;
  margin: 0 auto;
  background: none;

  .input-group {
    margin-bottom: 20px;
  }

  .input-group-addon {
    display: inline-block;
    width: 38px;
    text-align: center;
    background: #eaeaea;
    line-height: 33px;
    color: #fff;
  }

  .sub {
    background: $bgColor;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/components/ChangeStatefirst.vue